import { render, staticRenderFns } from "./modifyuserinfo.vue?vue&type=template&id=0534624e&scoped=true"
import script from "./modifyuserinfo.vue?vue&type=script&lang=js"
export * from "./modifyuserinfo.vue?vue&type=script&lang=js"
import style0 from "./modifyuserinfo.vue?vue&type=style&index=0&id=0534624e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0534624e",
  null
  
)

export default component.exports